/**
 * src/gm/platform/model-map.ts — 稀有度 → 模型 / 推理强度映射（继承 spike 修正结论）。
 *
 * spike 实测修正两条（设计稿 §9.1/§9.2）：
 *  ① 所有 kimi-k3 调用必须显式带 reasoning_effort——不传会在复杂代码任务上
 *    闷头推理 280s 零可见输出（前端死屏 + 账单翻倍）。
 *  ② 程序岗大输出（15–30K token）任何稀有度都走 kimi-k3 + low：
 *    kimi-k2.6 吞吐只有 k3 的 1/3（17 tok/s），大输出要 40–80 分钟，禁用。
 */

import type { Rarity } from './save-types'

export interface ModelChoice {
  model: string
  reasoningEffort?: 'low' | 'medium' | 'high'
}

const MODEL_MAP: Record<Rarity, ModelChoice> = {
  rookie: { model: 'kimi-k2.6' }, // 短输出岗位便宜快速；不带 effort（非推理模型）
  veteran: { model: 'kimi-k3', reasoningEffort: 'medium' },
  legend: { model: 'kimi-k3', reasoningEffort: 'high' },
}

/** 程序岗强制 k3 + low（spike 修正：又便宜又快，推理少还省输出费） */
const PROGRAMMER_CHOICE: ModelChoice = { model: 'kimi-k3', reasoningEffort: 'low' }

/** 评审员固定 k3 + high（打分质量直接影响经营循环，不省这个钱） */
export const REVIEWER_CHOICE: ModelChoice = { model: 'kimi-k3', reasoningEffort: 'high' }

export type GmStage = 'plan' | 'art' | 'code' | 'review'

/** 按员工稀有度 + 阶段查模型映射（程序岗走修正档） */
export function modelFor(rarity: Rarity, stage: GmStage): ModelChoice {
  if (stage === 'code') return PROGRAMMER_CHOICE
  if (stage === 'review') return REVIEWER_CHOICE
  return MODEL_MAP[rarity]
}

export const ROLE_LABEL: Record<string, string> = {
  designer: '策划',
  programmer: '程序',
  artist: '美术',
}
